import type { MathflatResultError, MathflatResultSuccess } from ':/@common/result/index'

export const mathflatResultError = <RE extends MathflatResultError>(re: RE) => re
export const mathflatResultSuccess = <RE extends MathflatResultSuccess>(re: RE) => re
